'use client';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 3rem;
`;

export default function Divider() {
  return <Wrapper>&nbsp;</Wrapper>;
}
